import { Input, Tooltip } from "antd";
import { formatNumber } from "../utils/numberUtils";
import { useCallback, useMemo } from "react";

interface NumericInputProps {
  style: React.CSSProperties;
  value: string;
  placeholder?: string;
  onChange: (value: string) => void;
  suffix?: string;
}

export default function NumericInput({style, value, placeholder, onChange, suffix}: NumericInputProps) {

  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const { value: inputValue } = e.target;
    const reg = /^-?\d*(\.\d*)?$/;
    if (reg.test(inputValue) || inputValue === "" || inputValue === "-") {
      onChange(inputValue);
    }
  }, [onChange]);

  const handleBlur = useCallback(() => {
    let valueTemp = value;
    if (value.charAt(value.length - 1) === "." || value === "-") {
      valueTemp = value.slice(0, -1);
    }
    onChange(valueTemp.replace(/0*(\d+)/, "$1"));
  }, [onChange, value]);

  const title = useMemo(
    () =>
      value ? (
        <span className="numeric-input-title">
          {value !== "-" ? formatNumber(Number(value)) : "-"}
        </span>
      ) : (
        "Inserisci un valore numerico"
      ),
    [value]
  );

  return (
    <Tooltip
      title={title}
      placement="topLeft"
      classNames={{ root: "numeric-input" }}
    >
      <Input
        style={style}
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder={placeholder || "Inserisci un valore numerico"}
        suffix={suffix}
        maxLength={16}
      />
    </Tooltip>
  );
}
